<template>
  <div class="mobile_apply_list" :class="{ owner: !isCustomer }">
    <div class="a_list_wrap" v-for="(item, index) in list" :key="index">
      <div class="a_list_top">
        <div class="a_list_top_1">
          <div class="txt_1">
            {{ getCreateAt(item.createdAt) }}
          </div>
        </div>
        <!-- <div
          class="a_list_top_2 pnt"
          v-if="isCustomer"
          @click="goReportStore(item)"
        >
          신고하기
        </div>
        <div
          class="a_list_top_2 pnt"
          v-else
          @click="goReport(item.user.id, item.user.nickname)"
        >
          신고하기
        </div> -->
      </div>
      <!-- 사용자 -->
      <div class="profile" v-if="isCustomer">
        <div class="n_thumb pnt" v-if="getDealChk(deal, item.dealCd)">
          <div class="n_thumb_inner">
            <img
              :src="
                require(`@/assets/front/images/v2/deal/img_hanapay_logo.png`)
              "
              alt=""
            />
          </div>
        </div>
        <div class="n_thumb pnt" v-else>
          <div class="n_thumb_inner" v-if="item.store.storeProfile">
            <img :src="item.store.storeProfile" alt="" />
            <img
              class="mark"
              src="@/assets/front/images/new/icon_consent_s.png"
            />
          </div>
          <div class="n_thumb_inner" v-else>
            <img
              :src="setShopProfileImg(item.store.storeName, item.storeId)"
              alt=""
            />
            <img
              class="mark"
              src="@/assets/front/images/new/icon_consent_s.png"
            />
          </div>
        </div>
        <div class="pro_txt">
          <h1 class="name" v-if="getDealChk(deal, item.dealCd)">
            하나Pay
          </h1>
          <h1 class="name" v-else>
            {{ item.store.storeName }}
          </h1>
          <div class="none_face" v-if="item.applyType == 'APPLY'">
            <img
              :src="require('@/assets/front/images/v2/icons/i_box_01.svg')"
            />
            <div class="txt">비대면</div>
          </div>
          <div class="store_visit" v-if="item.applyType == 'PROMISE'">
            <img
              :src="
                require('@/assets/front/images/v2/icons/ic_chat_btn_store.svg')
              "
            />
            <div class="txt">매장방문</div>
          </div>
        </div>
      </div>

      <!-- 사장님 -->
      <div class="profile" v-else>
        <div class="n_thumb">
          <div class="n_thumb_inner">
            <img
              :src="
                item.user.photoThumb
                  ? item.user.photoThumb
                  : require(`@/assets/front/images/v2/profiles/img_profile_${getProfileNum(
                      item.user.id,
                    )}.png`)
              "
              alt=""
            />
          </div>
        </div>
        <div class="pro_txt">
          <h1 class="name">{{ item.user.nickname }}</h1>
          <div class="none_face" v-if="item.applyType == 'APPLY'">
            <img
              :src="require('@/assets/front/images/v2/icons/i_box_01.svg')"
            />
            <div class="txt">비대면</div>
          </div>
          <div class="store_visit" v-if="item.applyType == 'PROMISE'">
            <img
              :src="
                require('@/assets/front/images/v2/icons/ic_chat_btn_store.svg')
              "
            />
            <div class="txt">매장방문</div>
          </div>
        </div>
      </div>

      <div class="center_btn">
        <button class="btn_list_1" @click="goApplyDetail(item)">
          <img
            :src="
              require('@/assets/front/images/internet_commerce/i_btn_list_b.svg')
            "
          />
          <span>신청서 보기</span>
        </button>
        <button
          class="btn_list_2"
          v-if="isCustomer"
          @click="goToReviewWrite(item)"
        >
          <img
            :src="
              require('@/assets/front/images/internet_commerce/i_review_write.svg')
            "
          />
          <span>리뷰 작성하기</span>
        </button>
        <button class="btn_list_2" v-else @click="goToReview(item.storeId)">
          <img
            :src="
              require('@/assets/front/images/internet_commerce/i_review_write.svg')
            "
          />
          <span>리뷰 바로가기</span>
        </button>
        <button class="btn_list_3" @click="enterChatRoom(item)">
          <img
            :src="
              require('@/assets/front/images/internet_commerce/ic_list_chat_white.svg')
            "
          />
          <span>채팅</span>
        </button>
      </div>
      <div class="con_info">
        <div class="info_list">
          <div class="txt_1">상품구성</div>
          <div class="txt_2">{{ item.modelName }}</div>
        </div>
        <div class="info_list">
          <div class="txt_1">가입요금제</div>
          <div class="txt_2">{{ item.joinPlanName }}</div>
        </div>
        <div class="info_list">
          <div class="txt_1">약속지원금</div>
          <div class="txt_2">{{ toCurrency(item.storeSupportMoney) }}원</div>
        </div>
        <div class="info_list">
          <div class="txt_1">월 납부금액</div>
          <div class="txt_2">
            {{ toCurrency(item.joinTotalPrice) }}원 ({{
              getJoinPlanDuty(item.joinPlanDuty)
            }})
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as util from '@common/lib/common/utils.js';
import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';

import { ko as dateKo } from 'date-fns/locale';
import promotionCfg from '@common/lib/common/promotionCfg';
export default {
  name: 'component-mobile-apply-list',
  description: '휴대폰 신청현황',
  components: {},
  props: {
    isCustomer: {
      type: Boolean,
      default: false,
    },
    list: Array,
    deal: {
      type: String,
      default: '',
    },
  },
  filters: {
    comma(val) {
      return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    nl2br(val) {
      return String(val)
        .split('\n')
        .join('<br />');
    },
  },
  data() {
    return {
      planDuty: [
        { name: '0개월 (없음)', value: '0' },
        { name: '1개월', value: '1' },
        { name: '2개월', value: '2' },
        { name: '3개월', value: '3' },
        { name: '4개월', value: '4' },
        { name: '5개월', value: '5' },
        { name: '6개월', value: '6' },
        { name: '0개월 (없음)', value: '0M' },
        { name: '1개월', value: '1M' },
        { name: '2개월', value: '2M' },
        { name: '3개월', value: '3M' },
        { name: '4개월', value: '4M' },
        { name: '5개월', value: '5M' },
        { name: '6개월', value: '6M' },
        { name: 'D+93일', value: 'D+93' },
        { name: 'D+95일', value: 'D+95' },
        { name: 'D+123일', value: 'D+123' },
        { name: 'D+125일', value: 'D+125' },
        { name: 'M+3개월', value: 'M+3' },
        { name: 'M+4개월', value: 'M+4' },
        { name: 'M+6개월', value: 'M+6' },
      ],
    };
  },
  created() {},
  computed: {},
  methods: {
    toCurrency(val) {
      return util.toCurrency(val);
    },
    getCreateAt(createAt) {
      return format(parseISO(createAt), 'yyyy.MM.dd');
    },
    setShopProfileImg(shopName, shopId) {
      let path = util.setShopProfile(shopName, shopId, '140x140');

      return path;
    },
    // 매장이 사용자 신고
    goReport(userId, userNickName) {
      this.$emit('user-report', userId, userNickName);
    },
    // 고객이 매장 신고
    goReportStore(item) {
      this.$emit('goReportStore', item);
    },
    getJoinPlanDuty(joinPlanDuty) {
      console.log(joinPlanDuty);
      const foundInfo = this.planDuty.find(info => info.value === joinPlanDuty);
      if (foundInfo == undefined) {
        return joinPlanDuty + '개월';
      }

      return foundInfo.name;
    },
    goApplyDetail(item) {
      if (this.isCustomer) {
        this.$emit('apply-detail', item);
      } else {
        this.$emit('apply-detail', item);
        // /this.$emit('internet-voucher', item.id);
      }
    },
    enterChatRoom(item) {
      if (this.isCustomer) {
        if (item.store.storeDel) return;
        this.$emit('enter-chat', item.storeId);
      } else {
        this.$emit('enter-chat', item.chatroomUuid);
      }
    },
    goToReviewWrite(item) {
      this.$emit('review-write', item);
    },
    goToReview(storeId) {
      this.$emit('review', storeId);
    },
    getProfileNum(userId) {
      return util.setProfile(userId);
    },
    getDealChk(deal, dealCd) {
      if (deal == 'hanapay' && dealCd != '' && dealCd != null) {
        if (dealCd.indexOf('HANAPAY') != -1) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
  },
};
</script>
